/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o índice e as
 * duas subcamadas do mapa.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { TrackingLayerManager } from './layer';
import { iniciarSyncRastreio, registrarNovaTentativa } from './sync';
import { TrackingPopup } from './TrackingPopup';

export { refreshRastreio } from './sync';

export function useTrackingLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncRastreio(), []);

  useEffect(() => {
    if (!map) return;
    const manager = new TrackingLayerManager(map, (sistema) => createElement(TrackingPopup, { sistema }));
    registrarNovaTentativa(() => manager.tentarDeNovo());
    return () => {
      registrarNovaTentativa(null);
      manager.dispose();
    };
  }, [map]);
}
